import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phoneclose",
  "use": "icon-phoneclose-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol class=\"svg-icon-path-icon fill\" viewBox=\"0 0 32 32\" id=\"icon-phoneclose\"><path d=\"M26.343 25.051l-9.051-9.051 9.051-9.051-1.616-1.617-9.051 9.052-8.89-8.891-1.616 1.617 8.89 8.89-8.89 8.89 1.616 1.616 8.89-8.89 9.051 9.052z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phoneclose.svg
// module id = Yqm0
// module chunks = 22